module.exports = {"pipeline":{"name":"pipeline-imgListScroll","title":"图片滑动组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-imgListScroll/package.json
// module id = 528
// module chunks = 2